module.exports = __webpack_public_path__ + "static/media/drop-down.8636e895.svg";